import { useEffect, useRef, useState } from "react";
import loader from "../../../assets/images/loader.gif";
import noimg from "../../../assets/images/noimg.webp";
import Pagination from "../../../components/common/Pagination";
import ListAction from "../../../components/dashboard/admin-dashboard/ListAction";
import ProjectDetailModal from "../../../components/dashboard/admin-dashboard/detail-modal/ProjectDetailModal";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import {
  deleteProject,
  getAllProjectList,
} from "../../../service/DashboardService";
import { getProjectById } from "../../../service/MainService";
import DoubleConfirm from "../../../components/dashboard/common/DoubleConfirm";

const AllProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [projectDetail, setProjectDetail] = useState();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalProjectCount, setTotalProjectCount] = useState(0);
  const topRef = useRef(null);
  const [deletingProjectId, setDeletingProjectId] = useState(null);
  const [doubleAlert, setDoubleAlert] = useState(false);

  useEffect(() => {
    fetchData();
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getAllProjectList(currentPage, 10);
      setProjects(response.Result);
      setTotalProjectCount(response.TotalProjectCounts);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching projects:", error);
      setLoading(false);
    }
  };

  const handleViewClick = async (projectId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await getProjectById(projectId, token);
      setProjectDetail(response);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handlePageChange = (page, e) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleDeleteProject = async (projectId) => {
    setDeletingProjectId(projectId);
    setDoubleAlert(true);
  };

  const confirmDeleteProject = async () => {
    try {
      await deleteProject(deletingProjectId);
      setProjects((prevProjects) =>
        prevProjects.filter(
          (project) => project.ProjectId !== deletingProjectId
        )
      );
      setDeletingProjectId(null);
      setDoubleAlert(false);
    } catch (error) {
      console.error("Error deleting project:", error);
    }
  };

  const renderTableRows = () => {
    return projects?.map((project, i) => (
      <tr
        key={i}
        className="bg-white border-b  dark:bg-gray-800 dark:border-gray-700"
      >
        <td className="px-6 py-4">{project.ProjectName || "NA"}</td>
        <td className="px-6 py-4">
          <img
            src={project.ImageUrls[0] || noimg}
            alt={project.ProjectName || "Project Preview"}
            className="w-20 shadow-md mx-auto object-cover"
            style={{width:'80px', height:'80px'}}
          />
        </td>
        <td className="px-6 py-4">{project.TypologyCategory || "NA"}</td>
        <td className="px-6 py-4">{project?.Country?.countryName || "NA"}</td>
        <td className="px-6 py-4">{project?.user?.UserName || "NA"}</td>
        <td
          className={`px-6 py-4 font-semibold ${
            project.ProjectStatus === "APPROVED"
              ? "text-green-600"
              : project.ProjectStatus === "REJECTED"
              ? "text-red-600"
              : ""
          }`}
        >
          {project.ProjectStatus || "NA"}
        </td>
        <td className="px-6 py-4">
          <ListAction
            onViewClick={() => handleViewClick(project.ProjectId)}
            onDeleteClick={() => handleDeleteProject(project.ProjectId)}
            showDeleteButton={true}
          />
        </td>
      </tr>
    ));
  };

  return (
    <>
      <div ref={topRef} />
      <TopHeader />
      {/* <SearchBar /> */}
      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      ) : (
        <div>
          <table className="w-full text-sm text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase text-center bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Project Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Main Image (Preview)
                </th>
                <th scope="col" className="px-6 py-3">
                  Typology
                </th>
                <th scope="col" className="px-6 py-3">
                  Country
                </th>
                <th scope="col" className="px-6 py-3">
                  Owner
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3"></th>
              </tr>
            </thead>

            <tbody>
              {projects.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No records found
                  </td>
                </tr>
              ) : (
                renderTableRows()
              )}
            </tbody>
          </table>
          {totalProjectCount > 10 && (
            <Pagination
              currentPage={currentPage}
              totalItems={totalProjectCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}
      {projectDetail && (
        <ProjectDetailModal
          open={open}
          setOpen={setOpen}
          projectDetail={projectDetail}
        />
      )}
      <DoubleConfirm
        open={doubleAlert}
        setOpen={setDoubleAlert}
        onConfirm={confirmDeleteProject}
      />
    </>
  );
};

export default AllProjectList;
